import { HrmActions } from "../../pages/components/hrm_actions";

export const adminNewsLetterColumns = ({ onSelectAction }) => {
  return [
    {
      Header: "Sr. No.",
      accessor: "idd", // Assuming you set 'idd' correctly in the data
      Cell: ({ row }) => {
        return row.original.idd; // Return the idd value
      },
    },
    {
      Header: "Email",
      accessor: (row) => {
        return row?.email || "N/A";
      },
    },
    {
      Header: "Actions",
      accessor: (row) => {
        return (
          <div className="text-left">
            <HrmActions
              onSelectAction={onSelectAction}
              row={row}
              isDelete={true}
            />
          </div>
        );
      },
    },
  ];
};
